import React, { FC } from 'react';

import { useI18n } from '../../hooks/useI18n';

import styles from './_SeasonInfo.module.css';

interface SeasonInfoProps {
    number: number;
    episodesCount: number;
}

export const SeasonInfo: FC<SeasonInfoProps> = ({ number, episodesCount }) => {
    const i18n = useI18n();

    return (
        <section className={styles.season}>
            <span className={styles.seasonTitle}>
                {i18n('season_number', { seasonNumber: number })}
            </span>
            <span className={styles.seasonEpisodesCount}>
                {episodesCount} {i18n('plural_episodes_count', { episodesCount })}
            </span>
        </section>
    );
};
